import { Fragment } from 'react';

import { YOUR_DETAILS_FIELDS, MOBILE_PHONE_NUMBER } from '~/routes/about-you/about-you-form/sections';
import { msToAmPmHours } from '~/routes/utils';

const YOUR_DETAILS_FIELDS_FITTED_BEDROOMS = [
  YOUR_DETAILS_FIELDS[0],
  YOUR_DETAILS_FIELDS[1],
  MOBILE_PHONE_NUMBER,
];

export const config = {
  AboutIntro: {
    title: 'About you',
  },
  AboutYouForm: {
    sectionDataTest: 'YourAppointmentFittedBedrooms',
    yourDetailsFields: YOUR_DETAILS_FIELDS_FITTED_BEDROOMS,
    formatTimeSlot: time => (
      <Fragment>
        {' '}
        <span>
          at&nbsp;
          {msToAmPmHours(time)}
        </span>
      </Fragment>
    ),
  },
};
